import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-expire-date-dialog',
  templateUrl: './expire-date-dialog.component.html',
  styleUrls: ['./expire-date-dialog.component.css']
})
export class ExpireDateDialogComponent implements OnInit {

  innerHeight: number = window.innerHeight;


  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    public dialogRef: MatDialogRef<ExpireDateDialogComponent>,
    private tools: ToolsService
  ) { }


  ngOnInit() {
   
  }

  closeDial() {
    this.dialogRef.close();
  }



}
